import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { useSearchCrawlersQuery } from 'queries/crawler'
import { setSupplier, getSupplier } from 'store/invoices/crawler'
import { Select, FormGroup } from 'library'

const SupplierSelect = () => {
  const dispatch = useDispatch()
  const selected = useSelector(getSupplier)
  const { data, isFetching } = useSearchCrawlersQuery({ suspense: false })

  const options = Object.values(data?.suppliers ?? []).map((supplier) => ({
    value: supplier.code,
    label: supplier.name,
  }))

  /* Select first provider */
  useEffect(() => {
    if (selected !== null || isEmpty(options)) return
    dispatch(setSupplier(options[0].value))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, selected])

  return (
    <FormGroup label="Fournisseur">
      <Select
        value={options.filter((option) => option.value === selected)}
        options={options}
        isLoading={isFetching}
        onChange={(option: any) => {
          dispatch(setSupplier(option ? option.value : null))
        }}
        placeholder=""
      />
    </FormGroup>
  )
}

export default SupplierSelect
